module.exports = __webpack_public_path__ + "static/sedna-logo-2936d57bf32afd27e83baa556af91205.png";